import Vue from 'vue';
import { loadLanguage } from '../../../core/i18nUtils';

export default (i18n) => {
  const vue = new Vue({
    el: '#project-office',
    i18n,
    template: '<project />',
    components: {
      Project: () => import('./Project'),
    },
    async beforeCreate() {
      await loadLanguage(this, ['main', 'stock_info']);

      switch (window.lang) {
        case 'english':
          this.$i18n.locale = 'en';
          break;
        case 'gb':
          this.$i18n.locale = 'gb';
          break;
        default:
          this.$i18n.locale = 'zh';
      }
    },
  });

  return vue;
};
